import { CareerPathScoreSection, ColorToken } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const STRINGS = appStrings.modules.survey.output.blueprintSection.careerPaths.detail;

export type FitGroup = Readonly<{
  scoreSection: CareerPathScoreSection;
  label: string;
  dotColor: ColorToken;
}>;

export const FIT_GROUPS: readonly FitGroup[] = [
  { scoreSection: 'TOP', label: STRINGS.strongFit, dotColor: 'Brand/600' },
  { scoreSection: 'MIDDLE', label: STRINGS.mediumFit, dotColor: 'Brand/300' },
  { scoreSection: 'LOW', label: STRINGS.lowFit, dotColor: 'GrayBlue/300' },
];
